const announcementBar = class extends HTMLElement {
  constructor() {
    super()

    this.swiper = null
    this.swiperEl = this.querySelector('[data-announcement-bar-slider]')
    this.autoPlay = Boolean(this.dataset.autoplay === 'true')
    this.prev = this.querySelector('[data-announcement-bar-prev]')
    this.next = this.querySelector('[data-announcement-bar-next]')

    this.speed = Number(this.dataset.speed) * 1000
    this.options = {
      slidesPerView: 1,
      threshold: 10,
      draggable: true,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      ...(this.autoPlay) && { autoplay: {
          delay: this.speed,
          pauseOnMouseEnter: true
        }
      },
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      loop: true
    }
  }

  connectedCallback() {
    this.swiper = new Swiper(this.swiperEl, this.options)
  }
}

if (typeof window.customElements.get('announcement-bar') === 'undefined') {
  window.customElements.define('announcement-bar', announcementBar)
}